import styled from 'styled-components';
import { Layout } from 'antd';

export const Sider = styled(Layout.Sider)`
  min-height: 100vh;

  /*
   * Container do menu: altura = janela.
   * Sem isso, Logo + Menu(calc svh) + trigger estouram a viewport
   * e a barra de recolher some no Firefox após o paint.
   */
  .ant-layout-sider-children {
    position: fixed;
    top: 0;
    width: inherit;
    height: 100vh;
    height: 100dvh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  /* nav envolve busca + itens — ocupa o espaço entre Logo e a barra */
  .ant-layout-sider-children > nav {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
`;

/** Área do botão expandir/recolher — sempre no rodapé da janela, mesma cor do sider */
export const SiderCollapseTrigger = styled.div`
  flex-shrink: 0;
  padding: 12px 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
`;
